import { render, staticRenderFns } from "./TransactionList.vue?vue&type=template&id=4ef432f8&scoped=true"
import script from "./TransactionList.vue?vue&type=script&lang=js"
export * from "./TransactionList.vue?vue&type=script&lang=js"
import style0 from "./TransactionList.vue?vue&type=style&index=0&id=4ef432f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef432f8",
  null
  
)

export default component.exports